import { apiAction } from './api';
export const GET_PLAYLIST = 'GET_PLAYLIST';
export const SET_PLAYLIST = 'SET_PLAYLIST';
import endpoints from './endpoints';

export const getPlaylist = () => {
  return apiAction({
    url: endpoints.getPlaylist,
    onSuccess: setPlaylist,
    label: GET_PLAYLIST,
  });
};

const setPlaylist = (data) => {
  return {
    type: SET_PLAYLIST,
    payload: [
      {
        id: '',
        companyName: '',
        companyShortName: '',
        incidentName: '',
        maxProcedure: 802735,
        recentProcedureCount: 6,
        type: 'DRAFT',
        status: 'RUNNING',
        taskId: -1,
        taskName: 'New',
        taskNumber: 1,
        noCharge: 0,
      },
      ...data,
    ],
  };
};

export const playlist = (state = [], action) => {
  switch (action.type) {
    case SET_PLAYLIST:
      return action.payload;
    default:
      return state;
  }
};
